/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useState,useEffect,useContext} from 'react'
import ReactModal from 'react-modal';
import Modal from 'react-modal'
import { CDN, exceptThisSymbols } from '../../constants';
import ClearCart from '../../Pages/OfferDetails/ClearCart';
import { WishlistExist } from '../../redux/helper/AddWishlist';
import { CartPayload } from '../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../Context/HeaderContext';
import WishlistContext from '../Context/WishlistContext';
import ThreeDotsLoader from '../LoadingDots';

export default function AddToCart({product,isClose,handlefetch,Cart}) {
    const [quantity, setquantity] = useState();
    const [removePopup, setremovePopup] = useState('');
    const [removeLoader, setremoveLoader] = useState(false);
    const handleProductCount=()=>{
        let count=(product?.MINIMUM_ORDER_QUANTITY ||1) < (product?.PACKING_SIZE || 1)? (product?.PACKING_SIZE ||1) : (product?.MINIMUM_ORDER_QUANTITY ||1);
        return count;
    }
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setquantity(handleProductCount())
    }, [product])
    
    const [quantityError, setquantityError] = useState(false);
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
     
    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        isClose('')
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setloading(false)

        }, 1000);
    }
    const handleSuccessMessage = (message)=>{
        SetSuccessMessage(message);
        // handlefetch()
        setTimeout(() => {
            SetSuccessMessage('');
            isClose({});
            setcolorValue(false);
            setloading(false)
        },1000)
    }
    const haddleError = () =>{
        if(Math.round(quantity * 10000) % Math.round((product?.PACKING_SIZE|| 1) * 10000) !==0){
            setquantityError(true);
        }
        else{
            setquantityError(false);
        }
    }
    const handleConfirm = async()=>{
        setloading(true)
        const payload=CartPayload(product,quantity)
        const res = await distributorService.AddToCart(payload);
        if(!res.error && res.data.success_status){
            handleSuccessMessage(res.data.message)
        }else{
            if(res?.message?.response?.data?.special_offer_exist){
                setremovePopup('active');
                SetErrorMessage(res?.message?.response?.data?.message ||'Something went wrong');
                setcolorValue(true);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                    setloading(false)
                }, 1000);
            }else{
                handleErrorMessage(res?.message?.response?.data?.message);

            }
        }
    }
    

    
    const minQuantity = Number(product?.MINIMUM_ORDER_QUANTITY) || Number(product?.PACKING_SIZE) || 1;
    // One pack step down would fall below the MOQ (also covers MOQ smaller than pack size)
    const isAtMinQuantity = (Math.ceil(Number(quantity) / (Number(product?.PACKING_SIZE) || 1) - 1e-6) - 1)
        * (Number(product?.PACKING_SIZE) || 1) < minQuantity - 1e-6;
    const handleQuantity = (type, quantity) => {
        const current = Number(quantity);
        if (type === '+' && current < Number(handleProductCount(product))) {
            const count = handleProductCount(product);
            setquantity(count);
            handleCheck(count);
            return;
        }
        const pack = Number(product?.PACKING_SIZE) || 1;
        // Work in whole pack steps to avoid floating point modulo errors (e.g. 1.05 % 0.01)
        const steps = current / pack;
        const nextSteps = type === '+' ? Math.floor(steps + 1e-6) + 1 : Math.ceil(steps - 1e-6) - 1;
        const next = Number((nextSteps * pack).toFixed(4));
        if (type === '-' && next < minQuantity) return;
        setquantity(next);
        handleCheck(next);
    }
    
    const handleCheck = (copy) => {
        setquantityError(false);
        if (copy < Number(product?.MINIMUM_ORDER_QUANTITY) || (Math.round(copy * 10000) % Math.round((product?.PACKING_SIZE || 1) * 10000) !== 0)) {
            setquantityError(true);
        }
    };
    const handleClearCart=async()=>{
        const cart = await distributorService.clearCart();
        if(!cart.error && cart.data.success_status){
            setremovePopup('');
            handlefetch()
        
        }
    }
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    return (
        <>
            <ReactModal style={{overFlow:'auto'}} isOpen={removePopup!==''}>
                <ClearCart
                    // RemoveFromCart={RemoveFromCart}
                    setremovePopup={setremovePopup}
                    handleClearCart={handleClearCart}
                    handleAddBulkProducts={handleConfirm}
                    loading={removeLoader}
                    setremoveLoader={setremoveLoader}/>
            </ReactModal>
            <Modal
                style={{overFlow:'auto'}}
                isOpen={Object.keys(product).length >0 && removePopup===''}>
                <div className={`modal fade fixed top-0 left-0 ${removePopup !== '' ? 'hidden' : 'show'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="addtocart" tabIndex="-1" aria-labelledby="addtocart" aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-dialog-centered relative pointer-events-none sm:max-w-[444px] w-auto px-2" style={{ margin:"auto" }}>
                        <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                            <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md px-10">
                                <h5 className="sm:text-lg text-base font-semibold text-[#090406] text-center w-full border-b border-[#707070] lg:pb-[18px] pb-3.5" id="exampleModalScrollableLabel1">
                                    Add to Cart
                                </h5>
                                <button type="button"
                                    onClick={()=>{
                                        isClose({});
                                        setquantityError(false)

                                    }}
                                    className="btn-close1 box-content sm:w-4 sm:h-4 w-3 h-3 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-[22px] sm:right-5 top-4 right-4"
                                    data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body relative px-10 pt-[18px] text-center">
                                <div className={`flex justify-center`}>
                                    <img src={handleImage(product?.IMAGE_NAME)} alt="icon" style={{height:'104px',width:'137px',objetFit:'cover'}}/>
                                </div>
                                <p className="lg:text-xs4 md:text-lg text-base font-bold text-[#090406] text-center lg:pt-3.5 pt-1">{product?.MODEL_DESCRIPTION || `${product?.DESCRIPTION?.length > 20 ? `${product.DESCRIPTION.slice(0,20)}...`:`${product.DESCRIPTION}`}`}</p>
                                <p className="text-xs font-normal text-[#808285] pt-0.5">Product Code: {product.CONCATENATED_SEGMENTS} {product.AWS_CLASSIFICATION === null ? null : `| AWS Classification: ${product.AWS_CLASSIFICATION}`}</p>
                            </div>
                            <div className="pt-4">
                                <p className="text-xs6 font-semibold text-[#808285] text-center">Set Quantity</p>
                                <div className={`flex items-stretch mx-auto mt-2 w-fit h-[40px] rounded-md border bg-white overflow-hidden transition-colors ${quantityError ? 'border-[#ED1C24]' : 'border-[#CBCBCB] focus-within:border-[#555259]'}`}>
                                    <button
                                        onClick={()=>handleQuantity('-', quantity)}
                                        disabled={isAtMinQuantity}
                                        aria-label="Decrease quantity"
                                        title={isAtMinQuantity ? 'Quantity is at the minimum order quantity' : 'Decrease quantity'}
                                        type="button" className="w-[40px] flex items-center justify-center bg-[#E4E4EA] text-[#555259] border-r border-[#CBCBCB] hover:bg-[#555259] hover:text-white active:bg-[#3d3b40] active:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#E4E4EA] disabled:hover:text-[#555259]">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                    </button>
                                    <div className="flex items-center px-2 gap-1">
                                        <input value={quantity}
                                            type="text"
                                            inputMode="decimal"
                                            aria-label="Quantity"
                                            pattern="\d.*"
                                            onChange={(e)=>{
                                                setquantity(e.target.value);
                                                handleCheck(e.target.value)}}
                                            maxLength="11"
                                            onKeyUp={haddleError}
                                            onKeyDown={(e) => ['e', 'E', '+', '-',].includes(e.key) && e.preventDefault()}
                                            className="sm:w-[90px] w-[70px] h-full border-0 outline-none focus:outline-none focus:ring-0 shadow-none bg-transparent text-center sm:text-base text-[15px] font-semibold text-[#090406]" />
                                        <span className="text-sm font-semibold text-[#808285]">{product?.PRIMARY_UOM_CODE}</span>
                                    </div>
                                    <button
                                        onClick={()=>handleQuantity('+', quantity)}
                                        aria-label="Increase quantity"
                                        title="Increase quantity"
                                        type="button" className="w-[40px] flex items-center justify-center bg-[#E4E4EA] text-[#555259] border-l border-[#CBCBCB] hover:bg-[#555259] hover:text-white active:bg-[#3d3b40] active:text-white transition-colors">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                    </button>
                                </div>
                                <>{quantityError && <p className="text-xs3 font-normal text-[#ED1C24] pt-2 flex justify-center items-center">
                                    <span>
                                        <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer pr-1"/>
                                    </span>
                                    Quantity should be based on the MOQ and Standard Pack Size
                                </p>}</>
                                <div className="md:px-16 sm:px-10 px-5 lg:pt-[22px] pt-3">
                                    <div className="flex items-center justify-between">
                                        <p className="lg:text-xl sm:text-base text-sm font-semibold text-[#808285] pr-1">List Price</p>
                                        <p className="lg:text-xs11 sm:text-lg text-base font-semibold text-[#15090E]">{Number(product?.LIST_PRICE).toLocaleString('en-IN', {
                                            style: 'currency',
                                            currency: 'INR',
                                        })}</p>
                                    </div>
                                    <div className="flex items-center justify-between md:pt-2 pt-1">
                                        <p className="lg:text-xl sm:text-base text-sm font-semibold text-[#808285] pr-1">Amount</p>
                                        <p className="lg:text-xs11 sm:text-lg text-base font-semibold text-[#15090E]">{(product?.LIST_PRICE*quantity).toLocaleString('en-IN', {
                                            style: 'currency',
                                            currency: 'INR',
                                        })}</p>
                                    </div>
                                </div>
                                <div className="flex justify-center sm:pt-[33px] pt-6 pb-[18px]">
                                    <button type="buton"
                                        onClick={()=>{
                                            handleConfirm()
                                        }}
                                        disabled={quantityError ||quantity<=0}
                                        className="bg-[#555259] flex justify-center items-center rounded-lg md:w-[284px] w-[200px] md:h-10 h-8 text-sm font-semibold text-[#FFFFFF] cart-add"
                                        data-bs-dismiss="modal" aria-label="Close">
                                        <>{ loading?<ThreeDotsLoader/>:'Confirm'}</>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}